export default "__VITE_PUBLIC_ASSET__b964e3f5__"